const stock_opname = [
  {
    path: "/stock_opname",
    name: "stock_opname",
    component: () => import("../views/stock_opname/index.vue"),
  },
  {
    path: "/stock_opname/create",
    name: "stock_opname_create",
    component: () => import("../views/stock_opname/create.vue"),
  },
  {
    path: "/stock_opname/edit/:uuid",
    name: "stock_opname_edit",
    component: () => import("../views/stock_opname/edit.vue"),
  },
  {
    path: "/stock_opname/detail/:uuid",
    name: "stock_opname_detail",
    component: () => import("../views/stock_opname/detail.vue"),
  },
];

export default stock_opname;
